// goods.js
const goods = {
    add_channel: '添加渠道',
    confirm_delete_channel: '确定删除【{channel_name}】渠道吗？',
    add_goods: '添加门票',
    put_away: '上架',
    sold_out: '下架',
    please_select_object: '请选择对象',
    edit_max_out_promotion: '编辑满减促销',
    add_max_out_promotion: '添加满减促销',
    promotion_name: '促销活动名称',
    please_fill_in_promotion_name: '请填写促销活动名称',
    please_select_time_range: '请选择起止时间',
    in_progress: '进行中',
    please_select_promotion_goods: '请选择促销门票',
    please_set_discount_price: '请为每个门票设置优惠价格',
    channel_id: '渠道ID',
    channel_name: '渠道名称',
    end_date: '截止日期',
    channel_desc: '渠道说明',
    vip: '注册成为VIP',
    is_used: '是否启用',
    registration_identity: '注册身份',
    meeting_treatment: '参会待遇',
    collect_resume: '是否收集简历',
    is_collect: '收集',
    no_collect: '不收集',
    related_ticket: '关联门票',
    related_ticket_extra: '关联门票后，通过渠道链接进入网站只能看到已关联的门票',
    goods: '商品',
    title_login_top: '登录框顶部标题',
    login: '用户登录',
    login_left_text: '登录页左侧说明文字',
    collect_air: '是否收集行程',
    update_ticket: '编辑门票',
    add_ticket: '新增门票',
    ticket_info: '门票信息',
    ticket_name: '门票名称',
    ticket_num: '门票编号',
    ticket_type: '门票类型',
    ticket_type_1: '实物门票',
    ticket_type_2: '虚拟门票',
    sotre_num: '库存数量',
    ticket_resume: '门票简介',
    edit_coupon: '编辑优惠券',
    add_coupon: '添加优惠券',
    coupon_name: '优惠券名称',
    merchant_coupon: '商户券',
    ticket_coupon: '门票券',
    full: '满',
    reduce: '减',
    yuan: '元',
    issue_quantity: '发放量(张)',
    please_enter_issue_quantity: '请输入1-1000之间的整数',
    limit_per_person: '每人限领(张)',
    ticket_scope: '门票范围',
    please_select_ticket_scope: '请选择门票范围',
    all_tickets: '全部门票',
    entry_ticket: '入场券',
    ordinary_member_entry_ticket: '普通会员入场券',
    vip_member_entry_ticket: 'VIP会员入场券',
    unit: '张',
    activity_name: '活动名称',
    promotion_status: '促销状态',
    paused: '已暂停',
    going: '发行中',
    wait_start: '未开始',
    index: '序号',
    price: '单价',
    inventory: '库存',
    discounted_price: '优惠后价格',
    unlimited: '不限',
    basic_config: '基本配置',
    rule_name: '规则名称',
    implementation_period: '实行时段',
    description_info: '说明信息',
    condition_info: '条件信息',
    condition: '条件',
    please_select_logic_rule: '请选择逻辑规则',
    please_select_specific_parameters: '请选择具体参数',
    event_info: '事件信息',
    event: '事件',
    prompt_text_information: '提示文字信息',
    restrict_order_and_prompt_text_information: '限制下单并提示文字信息',
    collect_audit_attachment_materials: '收集审核附件材料',
    additional_content_collection_items: '附加内容收集项',
    please_select_field_type: '请选择字段类型',
    single_line_text: '单行文本',
    upload_file: '上传文件',
    please_select_maximum_number_of_files_to_upload: '请选择最多上传文件数量',
    most_upload: '最多上传',
    files: '个',
    please_select_file_types_to_upload: '请选择上传文件类型',
    please_select_form_collection_items: '请选择表单收集项，管理收集项请前往“用户”-“注册表单配置”',
    please_enter_prompt_content: '请输入提示内容',
    add_condition: '添加条件',
    add_event: '添加事件',
    step_1: '选择搭配门票',
    step_2: '搭配设置',
    step_3: '优惠设置',
    main_ticket: '主门票',
    add_main_ticket: '添加主门票',
    vice_ticket: '副门票',
    add_matching_ticket: '添加搭配门票',
    please_enter_ticket_name: '请输入门票名称',
    please_select_ticket_status: '请选择门票状态',
    ticket_status: '门票状态',
    on_shelf: '上架中',
    off_shelf: '已下架',
    activity_info: '活动信息',
    combination_name: '组合名称',
    combination_description: '组合简介',
    combination_type: '组合类型',
    self_selection_combination: '自选组合',
    fixed_combination: '固定组合',
    prompt: '提示',
    prompt_1: '套餐中的搭配门票，消费者可有选择的购买',
    prompt_2: '套餐所有门票打包出售，消费者需要成套购买',
    discount_info: '优惠信息',
    start_end_time: '起止时间',
    tickets_info: '门票信息',
    pieces: '件',
    yuan: '元',
    previous_step: '上一步',
    next_step: '下一步',
    select: '选择',
    status: '状态',
    ticket_shuxing: '门票属性',
    original_price: '原价',
    dapei_num: '搭配数量',
    dapei_price: '搭配价格',
    edit_full_sales: '编辑满件促销',
    add_full_sales: '添加满件促销',
    discount_name: '优惠名称',
    ticket_label: '门票',
    promotion_rules: '促销规则',
    number: '数量',
    pieces_discount: '件，打',
    discount: '折扣',
    dis_text: '折',
    add_rules: '添加规则',
    rules_1: '满件计算不包含历史订单，仅计算订单提交内容',
    please_fill_in_spend: '请填写满额',
    please_fill_in_discount: '请填写减额',
    add_jieti: '添加阶梯',
    error_1: '减额必须小于满额!',
    order_detail: '订单详情',
    basic_info: '基本信息',
    order_no: '订单编号',
    user_account: '用户账号',
    pay_method: '支付方式',
    payable_price: '应付价格',
    shi_price: '实付价格',
    pay_time: '支付时间',
    pay_status: '支付状态',
    ticket_holder: '持票人',
    payer: '支付人',
    cashier_order_no: '收银台订单号',
    audit_materials: '审核资料',
    audit_status: '审核状态',
    audit_remark: '审核备注',
    confirm_audit: '确认审核',
    invoice_info: '发票信息',
    invoice_record: '开票记录',
    invoice_type: '发票类型',
    invoice_title: '发票抬头',
    tax_number: '税号',
    invoice_content: '发票内容',
    no_invoice: '不需要发票',
    cost_info: '费用信息',
    total_amount: '合计金额',
    discount_amount: '优惠金额',
    amount_to_pay: '应付金额',
    actual_amount_paid: '实付金额',
    un_payment: '未支付',
    payment_info: '支付信息',
    view_receipt: '查看',
    confirm_modify: '确认修改',
    upload_failed: '只能上传doc、docx格式 和 图片',
    file_size_limit: '文件大小不能超过3M',
    upload_voucher: '汇款凭证',
    upload: '上传',
    viewing_files: '查看文件',
    no_files: '暂无文件',
    temp_no: '暂无',
    back_money_ing: '退款中',
    backed_money: '已退款',
    half_money: '部分退款',
    has_pay: '已支付',
    pass: '通过',
    no_pass: '驳回',
    order_remark: '订单备注',
    download: '下载',
    wait_pay: '待支付',
    upload_voucher_tips: '请上传汇款凭证',
    file_name: '文件名称',
    submit_time: '提交时间',
    type: '类型',
    file: '文件',
    details: '详情',
    small_total: '小计',
    invoice_1: '增值税普通发票',
    invoice_2: '增值税专用发票',
    invoice_3: '增值税普通电子发票',
    invoice_4: '定额发票',
    invoice_title_1: '个人',
    invoice_title_2: '企业性单位',
    invoice_title_3: '非企业性单位',
    file_link: '文件链接',
    invoice_details: '发票详情',
    need_text: '需要',
    no_need_text: '不需要',
    tax_number_1: '医院/科研院所高校等有税号的单位',
    tax_number_2: '政府/部队无税号单位',
    tax_number_3: '个人',
    organization: '单位',
    taxer_no: '纳税人识别号',
    receive_email: '收票人邮箱',
    invoice_address: '营业执照登记地址',
    tel: '注册固定电话',
    bank: '开户银行名称',
    base_account_no: '基本开户账号',
    receive_name: '收票人姓名',
    receive_mobile: '收票人手机',
    receive_address: '收票人地址',
    no_set_invoice: '未配置发票',
    refund_reason: '退款原因',
    refund_amount: '退款金额',
    refund_way: '退款方式',
    refund_from: '退款渠道',
    refund_way_1: '原路退回',
    refund_way_2: '拒绝退款',
    refund_way_3: '手动退款',
    account_bank: '开户行名称',
    account_no: '开户行账号',
    account_name: '开户人名称',
    account_mobiel: '开户人手机号',
    account_company: '开户人单位',
    refund_remark: '退款备注',
    refund_success: '退款成功',
    is_show: '是否在收银台显示',
    is_show_extra: '如果选择隐藏 该支付方式只会在会议后台显示，代表前台支付的时候不会显示该支付方式',
    other_name: '别名',
    pay_info: '支付说明',
    edit_jieti_sales: '编辑阶梯促销',
    add_jieti_sales: '添加阶梯促销',
    promotion_activity_set: '促销活动设置',
    select_promotion_ticket: '选择促销门票',
    ticket_discount_set: '门票优惠设置',
    enter_discount_price: '请填写优惠后价格',
    select_ticket: '选择门票',
    message: '优惠券：适用各种场景的优惠凭证。',
    enter_name_no: '请输入门票名称/编号',
    single_add: '添加',
    message_1: '限时促销：按时间段设定门票价格',
    start_time: '开始时间',
    end_time: '结束时间',
    delete_confirm_ticket: '确定删除该门票吗？',
    faxing_status: '发行状态',
    valid_start_time: '有效期起',
    valid_end_time: '有效期止',
    message_2: '搭配促销：多款门票搭配促销。',
    message_3: '满件促销：满件打折',
    message_4: '满额促销：满额减钱',
    channel_link: '渠道链接',
    confirm_delete_channel: '确定删除【{value}】渠道吗？',
    add_goods_type: '添加分类',
    enter_sort: '请输入排序',
    add_child_type: '增加子分类',
    goods_type: '分类',
    ticket_type_name: '门票类型名称',
    is_del_ticket: '是否删除该门票？',
    marketing_rules: '限购规则：应用于某些场景下，某些客户对指定门票的购买资格或购买数量的制约。',
    doing_status: '实行状态',
    audit: '审核',
    refund: '退款',
    goods_info: '商品信息',
    order_money: '订单金额',
    del_order: '确定删除该订单吗？',
    pay_inline: '线上支付',
    pay_outline: '线下支付',
    pay_name: '支付名称',
    show_refund_button: '是否显示退款按钮',
    collect_refund_account: '是否收集退款账号信息',
    refund_end_time: '退款截止时间',
    sale_count: '销售数量',
    sale_money: '销售金额',
    total: '合计',
    submit_order: '提交订单',
    audit_rejected: '审核不通过',
    audit_passed: '审核通过',
    payment_completed: '支付完成',
    completed: '完成',
    category: {
        new: '新增分类',
        edit: '编辑分类',
        parent_category: '请输入父级分类',
        enter_category_name: '请输入分类名称',
        child_type_limit: '请输入子类限制',
        select_category: '请输入可在该类别内选择',
        ticket_count_limit: '请输入门票数量限制',
        sort: '请输入排序',
        description_text: '请输入说明文字'
    },
    order_list: {
        mobile: '请输入手机号',
        user_name: '请输入用户名',
        order_no: '请输入订单编号',
        pay_way: '请选择支付方式',
        pay_status: '请选择支付状态',
        audit_status: '请选择审核状态',
        refund_status: '请选择退款状态',
        goods_type: '请选择门票分类',
        goods_name: '请选择门票名称'
    },
    invoice_list: {
        search_name: '姓名/单位/手机号/注册号',
        key_type: '关键字类型',
        key_type_name: '姓名',
        key_type_reg_no: '注册号',
        key_type_mobile: '手机号',
        key_type_company: '单位',
        key_type_email: '邮箱',
        key_type_pinyin: '简拼',
        pay_way: '请选择支付方式',
        invoice_type: '发票类型',
        invoice_type_normal: '增值税普通纸质发票',
        invoice_type_special: '增值税专用发票',
        invoice_type_electronic: '增值税普通电子发票',
        invoice_type_fixed: '定额发票',
        inv_title: '抬头类型',
        inv_title_personal: '个人',
        inv_title_organization: '医院/科研院所高校等有税号的单位',
        inv_title_government: '政府/部队无税号单位',
        open_status: '开票状态',
        open_status_no: '未开票',
        open_status_yes: '已开票',
        open_status_loading : '开票中',
        is_reg: '签到状态',
        is_reg_no: '未签到',
        is_reg_yes: '已签到',
        red_status: '退票状态',
        red_status_no: '未申请',
        red_status_yes: '已冲红',
        description: '发票备注',
        org_calss: '其他条件筛选',
        org_calss_inconsistent: '用户单位和抬头不一致',
        org_calss_tax_short: '税号小于18位',
        email_sms: '短信邮件发送状态',
        email_sms_no_email: '未发送邮件',
        email_sms_no_sms: '未发送短信',
        sort: '排序',
        sort_tax_asc: '税号正序',
        sort_time_desc: '发票索取时间倒序',
        individual: '个人',
        unit_name: '单位名称',
        needs_review: '需审核',
        not_registered: '未注册',
        no_payment: '暂无',
        paid: '已交费',
        unpaid: '未交费',
        invoice_title: '抬头/税号',
        mobile_email: '手机号码/邮箱',
        expense_type: '费用类型',
        regispay: '交费情况',
        payment_time: '交费时间',
        invoice_request_time: '索取发票时间',
        amount: '金额',
        del_invoice : '确定删除该发票吗',
    },
    order_invoice_edit: {
        invoice_title: '请选择发票抬头',
        invoice_content: '请选择发票内容',
        organization: '请输入单位',
        taxer_no: '请输入纳税人识别号',
        receive_email: '请输入收票人邮箱',
        invoice_address: '请输入营业执照登记地址',
        tel: '请输入注册固定电话',
        bank: '请输入开户行名称',
        base_account_no: '请输入基本开户账号',
        receive_name: '请输入收票人姓名',
        receive_mobile: '请输入收票人手机',
        receive_address: '请输入收票人地址',
        remark: '请输入备注',
        audit_remark: '请输入审核备注'
    },
    promotion: {
        promotion_name: '请输入促销活动名称',
        please_select_promotion_goods: '请选择促销门票',
        please_set_discount_price: '请为每个门票设置优惠价格',
        please_select_time_range: '请选择起止时间'
    },
    other_config: '其他配置'
};

export default goods;
